<mat-card appearance="outlined" class="primary-color-card" *transloco="let t">
  <div class="image-container">
    <img [src]="imageUrl().url" alt="" class="business-image" height="180px" mat-card-image width="100%" />
    @if (imageUrl().isSectorImage) {
      <mat-chip class="illustration-image-text">{{ t('SAMPLE_PHOTO') }}</mat-chip>
    }
  </div>
  <app-advertisement-chips [advertisement]="ad()" [categories]="categories()" />
  <mat-card-header class="business-header">
    <mat-card-title>{{ ad().title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="business-pricing">
    <mat-chip-set>
      <mat-chip disableRipple class="price-chip">{{ ad().rent_price ? t('FOR_RENT') : t('TAKEOVER') }}</mat-chip>
      <mat-chip disableRipple class="price-chip">
        <app-advertisement-price [priceType]="ad().price_type" [price]="ad().price" [rentPrice]="ad().rent_price" />
      </mat-chip>
    </mat-chip-set>
  </mat-card-content>
</mat-card>
